module.exports = __webpack_public_path__ + "img/Pl-T600.74f2d4d6.gif";